/**
 * Concierge — SSE stream consumer. The transport is the platform's one
 * `streamSSE` (`@services/sse`); the panel handles the extra `agent_card`
 * event type carried in `ConciergeStreamEvent`.
 */

import { streamSSE, type SseOptions } from '@services/sse';
import type { ConciergeStreamEvent } from '../types';

export function streamConciergeMessage(
  conversationId: string,
  payload: { message: string; model?: string },
  options?: SseOptions,
): AsyncGenerator<ConciergeStreamEvent, void, undefined> {
  return streamSSE<ConciergeStreamEvent>(
    `/concierge/conversations/${conversationId}/stream`,
    payload,
    options,
  );
}
